import Head from "next/head";

const Yotpo = () => {
  return (
    <Head>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
      (function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/${process.env.NEXT_PUBLIC_YOTPO_KEY}/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
      `,
        }}
      />
    </Head>
  );
};

export default Yotpo;
